import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'

interface Props {
  offer: App.Offer;
}

const Root = styled(Group)`
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const Image = styled.div`
  height: 100%;
  min-height: ${rem(140)};
  min-width: ${rem(120)};
  background-position: center;
  background-size: cover;

  ${mediaQueryUp.tablet} {
    min-height: ${rem(118)};
    min-width: ${rem(100)};
  }
`

const ContentContainer = styled(Group)`
  padding: ${rem(20)};
`

function ExpiredDealsOfferPill({
  offer,
}: Props) {
  const { image, property } = offer
  const propertyName = property?.name
  const imageId = image?.id

  const pillImageStyle = useMemo<React.CSSProperties>(() => {
    const imageUrl = imageId && getImageUrl(imageId, { height: 230 })
    return {
      backgroundImage: `url(${imageUrl})`,
    }
  }, [imageId])

  const offerText = propertyName ? `The ${propertyName} offer` : 'This offer'
  const body = `${offerText} is now over, but checkout other great deals below.`

  return (
    <LayoutContainer>
      <Root direction="horizontal">
        <Image style={pillImageStyle} />
        <ContentContainer direction="vertical" gap={4} verticalAlign="center">
          <Heading variant="heading5">
            You just missed it!
          </Heading>
          <BodyText variant="small">
            {body}
          </BodyText>
        </ContentContainer>
      </Root>
    </LayoutContainer>
  )
}

export default ExpiredDealsOfferPill
